
import { importSync as i } from '@embroider/macros';
let d = window.define;
d("mewe/templates/register", function(){ return i("mewe/templates/register.hbs");});
d("mewe/controllers/register", function(){ return i("mewe/controllers/register.js");});
d("mewe/routes/register", function(){ return i("mewe/routes/register.js");});
